// NATIVE

// INSTALLED

// CUSTOM
import { AxiosAdapter } from '../commons/adapters';

const http = new AxiosAdapter();

export const getLogsByPaginateService = async (page: number) => {
  try {
    return await http.get<any>(`/v1/log-actions?page=${page}&take=10`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getAreasByPaginateService ', error);
  }
};

export const getLogsService = async () => {
  try {
    return await http.get<any>(`/v1/log-actions`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getLogsService ', error);
  }
};
